import { Painter } from '@entities/painter'
import { Map } from '@features/map'
import { Outlet } from '@tanstack/react-router'
import { Suspense } from 'react'

export const MainPageLayout = () => {
  return (
    <>
      <Suspense>
        <Map>
          <Painter />
        </Map>
      </Suspense>
      <Outlet />
    </>
  )
}
